import type { InFilterDefinition } from '@factorialco/f0-react'
import { FormsEnumsStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const allStatuses: FormsEnumsStatusEnum[] = ['draft', 'scheduled', 'active', 'finished', 'archived']

const getStatusLabel = (status: FormsEnumsStatusEnum): string => {
  const labels: Record<FormsEnumsStatusEnum, string> = {
    draft: i18n.t('surveys.status.draft'),
    scheduled: i18n.t('surveys.status.scheduled'),
    active: i18n.t('surveys.status.active'),
    finished: i18n.t('surveys.status.finished'),
    archived: i18n.t('surveys.status.archived'),
  }
  return labels[status]
}

export const getFormStatusFilter = (
  statuses?: FormsEnumsStatusEnum[]
): InFilterDefinition<FormsEnumsStatusEnum> => {
  const statusesToInclude = statuses ?? allStatuses

  const filterOptions = statusesToInclude.map((status) => ({
    label: getStatusLabel(status),
    value: status,
  }))

  return {
    label: i18n.t('surveys.surveys_table.filters.status'),
    type: 'in' as const,
    options: {
      options: filterOptions,
    },
  }
}
